import { Button, CircularProgress } from "@mui/material";
import { useContext, useState } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { deleteDownload } from "../../services/bidiService";
import SimpleModal from "./SimpleModal";


const DeleteHistoryModal = ({ download, onDelete, ...props }) => {

  const authContext = useContext(AuthContext);

  const [loading, setLoading] = useState(false);

  const handleSubmit = (event) => {
    event.preventDefault();
    setLoading(true);
    deleteDownload(authContext.authData.customer_access_token, download.id).then(response => {
      setLoading(false);
      onDelete(download.id);
    }).catch(() => setLoading(false));
  };

  return <SimpleModal title="¿Deseas eliminar este libro del historial?" {...props}>
    {loading ? <div className="flex justify-center py-8"><CircularProgress /></div> :
      <div className="flex justify-center gap-2 pt-4">
        <Button fullWidth variant="outlined" onClick={() => props.onClose()}>No, gracias</Button>
        <Button fullWidth variant="contained" onClick={handleSubmit}>Si, eliminar</Button>
      </div>}
  </SimpleModal>
};

export default DeleteHistoryModal;